import { IsTest, getLang } from "@/utils/tools";
import { SpecicalVoteStep, isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    role_list: RoleInfo[];
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20240318030554-F678e28d587b6';
  const htmlurl = 'api/flow/Wand-20240322091608-F982bfe349f32';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20240318030721-F9948d7c6d193';
  const htmlurl = 'api/flow/Wand-20240322091608-F22e1cdca5110';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};


interface GetLoginedInitInfoRes extends commomRes {
  data: {
    get_saved_role_info: RoleInfo; // 角色信息
    guess_list: number[]; //当天竞猜
    vote_list: number[]; // 当天主投票
  };
}
// TODO htm 待确定
export const getLoginedInitInfo = async () => {
  const otherurl = 'api/flow/Wand-20240315071205-F4a09a9c69b2f';
  const htmlurl = 'api/flow/Wand-20240322091608-F5e78a4687f57';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};


export const getReward = async () => {
  const otherurl = 'api/flow/Wand-20240112015427-F89b3bb4cc697';
  const htmlurl = 'api/flow/Wand-20240112015814-F32bb53895d07';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitBet = async (guess_list: number[]) => {
  const otherurl = 'api/flow/Wand-20240315072424-F7f73e47fcf25';
  const htmlurl = 'api/flow/Wand-20240322091608-F5e8237de2bb4';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      guess_list,
    })
    .then((res) => res.data);
};

export const submitMainVote = async (vote_list: number[]) => {
  const otherurl = 'api/flow/Wand-20240315101152-Fd0ad8401e4bd';
  const htmlurl = 'api/flow/Wand-20240322091608-F44821d0b95c9';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      vote_list,
    })
    .then((res) => res.data);
};

export const submitSpecialVote = async (type: SpecicalVoteStep, tag_id: number|string) => {
  const otherurls = {
    [SpecicalVoteStep.One]: 'Wand-20240319141750-Ff84a0999d74f',
    [SpecicalVoteStep.Two]: 'Wand-20240320020136-Fc7b82b81a9be',
    [SpecicalVoteStep.Three]: 'Wand-20240320021402-F95c323c30b64',
    [SpecicalVoteStep.Four]: 'Wand-20240320021643-F3c29de4d0b55',
    [SpecicalVoteStep.Five]: 'Wand-20240320022712-F921ff2289b0c',
  }
  const htmlurls = {
    [SpecicalVoteStep.One]: 'Wand-20240322091608-Fe926f878fa13',
    [SpecicalVoteStep.Two]: 'Wand-20240322091608-Fbdcdb0b31a2b',
    [SpecicalVoteStep.Three]: 'Wand-20240322091608-F16007264aa03',
    [SpecicalVoteStep.Four]: 'Wand-20240322091608-F505eae606985',
    [SpecicalVoteStep.Five]: 'Wand-20240322091608-F9e704fdbdd8b',
  }
  // TODO
  const otherurl = `api/flow/${otherurls[type as keyof typeof otherurls]}`;
  const htmlurl = `api/flow/${htmlurls[type as keyof typeof htmlurls]}`;
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      tag_id,
    })
    .then((res) => res.data);
};

export const submitBetShare = async () => {
  const otherurl = 'api/flow/Wand-20240318021429-Fcdc0edd1b56f';
  const htmlurl = 'api/flow/Wand-20240322091608-F78fb449edd67';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitMainShare = async () => {
  // TODO
  const otherurl = 'api/flow/Wand-20240318021457-F91241cc2cd3c';
  const htmlurl = 'api/flow/Wand-20240322091608-F8196f434f995';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const getMainVoteNums = async () => {
  // TODO
  const otherurl = 'api/flow_direct/Wand-20240318021609-F04c8f17b63bc';
  const htmlurl = 'api/flow_direct/Wand-20240322091608-F2dd9eddfe76d';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: false,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetSpecialVoteNumsRes extends commomRes {
  data: {
    vote_log_list: {
      num: number;
      tag_id: number | string;
      timestamp: number;
    }[];
  };
}
export const getSpecialVoteNums = async (type: SpecicalVoteStep) => {
  const otherurls = {
    [SpecicalVoteStep.One]: 'Wand-20240319142004-F90617caf9d2c',
    [SpecicalVoteStep.Two]: 'Wand-20240320101814-F7ced0084f301',
    [SpecicalVoteStep.Three]: 'Wand-20240320101935-F0a491d6b9449',
    [SpecicalVoteStep.Four]: 'Wand-20240320102000-Fc4a270979de0',
    [SpecicalVoteStep.Five]: 'Wand-20240320102027-F593979e9efb5',
  }
  const htmlurls = {
    [SpecicalVoteStep.One]: 'Wand-20240322091608-F8e9d0eb73708',
    [SpecicalVoteStep.Two]: 'Wand-20240322091608-F27fdbc48fce9',
    [SpecicalVoteStep.Three]: 'Wand-20240322091608-Fa5c74f0939c2',
    [SpecicalVoteStep.Four]: 'Wand-20240322091608-F3a7f710b13d5',
    [SpecicalVoteStep.Five]: 'Wand-20240322091608-F8e8979d24452',
  }
  // TODO
  const otherurl = `api/flow/${otherurls[type as keyof typeof otherurls]}`;
  const htmlurl = `api/flow/${htmlurls[type as keyof typeof htmlurls]}`;
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetSpecialVoteNumsRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRewardRecordRes extends commomRes {
  data: {
    user_gift_collection_record: {
      daily_vote_present: Boolean;
      guess_present: Boolean;
      guess_share_present: Boolean;
      vote_present: Boolean;
      vote_share_present: Boolean;
    };
  };
}
export const getRewardRecord = async () => {
  // TODO
  const otherurl = 'api/flow/Wand-20240329092023-Fbdb0f99461ff';
  const htmlurl = 'api/flow/Wand-20240329093158-Fc7244e70cbeb';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRewardRecordRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};